
/*
 *
 * Login Api
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 03-Sep-2024
*/

import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'
import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/login/login')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

const getBaseUrl = () => {
  const isDevelopment = window.location.hostname === 'localhost'
  return isDevelopment ? window.location.origin : (process.env.APPLICATION_URL || window.location.origin)
}

const integrationEnvironmentHeaders = {
  development: 'INT1',
  development2: 'INT2',
  development3: 'INT3'
}

export async function userLogin (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/login-service/login/post-login',
      data: {
        rememberUserName: params.rememberUserName || false,
        isMobile: Capacitor.isNativePlatform() || false
      }
    })
    // window.sessionStorage.removeItem('isAuthorized')
    //  window.sessionStorage.removeItem('codeVerifier')
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function userLogout () {
  let data
  try {
    data = await axios({
      method: 'post',
      url: '/oauth2/logout',
      data: {
        clientAccessToken: window.sessionStorage.getItem('jwe')
      }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getCardHolderName (params) {
  let data
  try {
    if (Capacitor.isNativePlatform()) {
      const userCookie = await Preferences.get({ key: 'user_cookie' })
      if (userCookie && userCookie.value) {
        data = await axios({
          method: 'get',
          url: '/services/login-service/prelogin/retrieve-user?isMobile=true',
          data: { ...params },
          headers: {
            remember_me: userCookie.value
          }
        })
      } else {
        data = await axios({
          method: 'get',
          url: '/services/login-service/prelogin/retrieve-user?isMobile=true',
          data: { ...params }
        })
      }
    } else {
      data = await axios({
        method: 'get',
        url: '/services/login-service/prelogin/retrieve-user',
        data: { ...params }
      })
    }
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// export async function mfa (params) {
//   let data

//   try {
//     data = await axios({
//       method: 'post',
//       url: '/oauth2/mfa',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       data: JSON.stringify({ ...params })
//     })
//     return handlingResponse(data)
//   } catch (error) {
//     return handlingResponse(error)
//   }
// }
export function iamLogin (params) {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = `${process.env.API_REST_BE}/oauth2/login`
  form.style.display = 'none'

  const fields = {
    grant_type: 'PASSWORD',
    username: params.username,
    password: params.password,
    slider: params.captchaToken,
    ...(process.env.BANK === 'NEXIBUSINESS' && params.captchaVersion
      ? { captchaVersion: params.captchaVersion }
      : {}),
    Locale: 'it',
    Application: process.env.BANK === 'NEXIBUSINESS' ? 'NB' : process.env.BANK,
    Channel: 'web',
    ...(process.env.BANK === 'NEXIBUSINESS' && integrationEnvironmentHeaders[process.env.NODE_ENV]
      ? { ENV: integrationEnvironmentHeaders[process.env.NODE_ENV] }
      : {})
  }

  for (const [key, value] of Object.entries(fields)) {
    const input = document.createElement('input')
    input.name = key
    input.value = value
    form.appendChild(input)
  }

  document.body.appendChild(form)
  form.submit()
}

export async function token (params) {
  let data
  try {
    const currentPath = window.location.pathname
    const isLoginMos = currentPath.includes('/login-mos')

    let redirectUri

    if (isLoginMos) {
      redirectUri = `${getBaseUrl()}/login-mos`
    } else {
      redirectUri = `${getBaseUrl()}${process.env.PATH_LOGIN}`
    }

    const clientId = isLoginMos
      ? process.env.CLIENT_ID_MOS || process.env.CLIENT_ID
      : process.env.CLIENT_ID

    data = await axios({
      method: 'post',
      url: '/oauth2/token',
      data: `grant_type=${process.env.GRANT_TYPE}&code=${params.code}&redirect_uri=${redirectUri}&code_verifier=${params.codeVerifier}&client_id=${clientId}&scope=${process.env.SCOPE}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        riskIt: window.sessionStorage.getItem('riskIT')
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function ropcToken (params) {
  let data
  let userCookie = {
    value: null
  }

  if (Capacitor.isNativePlatform()) {
    userCookie = await Preferences.get({ key: 'user_cookie' })
  }

  if (params.refreshToken) {
    data = `grant_type=refresh_token&client_id=${process.env.CLIENT_ID_MOBILE}&refresh_token=${params.refreshToken}&scope=${process.env.SCOPE_MOBILE}`
  } else {
    if (params.rememberUserName && userCookie.value) {
      data = `grant_type=password&client_id=${process.env.CLIENT_ID_MOBILE}&password=${encodeURIComponent(params.password)}&scope=${process.env.SCOPE_MOBILE}`
    } else {
      data = `grant_type=password&client_id=${process.env.CLIENT_ID_MOBILE}&username=${encodeURIComponent(params.username)}&password=${encodeURIComponent(params.password)}&scope=${process.env.SCOPE_MOBILE}`
    }
  }

  if (!params.refreshToken && params.rememberUserName && userCookie.value) {
    try {
      data = await axios({
        method: 'post',
        url: '/oauth2/token',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          remember_me: userCookie.value
        },
        data
      })
      return handlingResponse(data)
    } catch (error) {
      return handlingResponse(error)
    }
  } else {
    try {
      data = await axios({
        method: 'post',
        url: '/oauth2/token',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data
      })
      return handlingResponse(data)
    } catch (error) {
      return handlingResponse(error)
    }
  }
}

export async function refreshContext (params) {
  let data

  try {
    data = await axios({
      method: 'POST',
      url: '/services/login-service/post-login/refresh-context',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function extendSession (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/login-service/auth/anon/ack-session',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getLoginNews (params) {
  let data
  try {
    data = await axios({
      method: 'get',
      url: '/services/communication-service/prelogin/get-news',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
